import React, { useEffect, useState, useCallback, useMemo } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {useDispatch} from 'react-redux';
import {useList} from 'react-use';
import {CSVLink} from 'react-csv';
import {useParams, useHistory} from 'react-router-dom';

import './style.scss';
import { getTeamPublic } from './../../../../actions/team-public';
import Loading from '../../../../components/loading';
import Pagination from '../../../../components/pagination';
import usePagination from "../../../../useHook/usePagination";
import {detectIconById} from "../../../../common/enum";

function TeamPublic() {
    const { currentPage, itemPerPage, totalPage, setTotalRecords, setCurrentPage } = usePagination(20);
    const [startDate, setStartDate] = useState(moment().subtract(30, 'd').toDate());
    const [endDate, setEndDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [list, listHelper] = useList([]);

    const dispatch = useDispatch();
    const history = useHistory();

    const params = useParams();

    useEffect(() => {
        fetchData(1, startDate, endDate);
    }, [startDate, endDate]);

    const fetchData = useCallback(async (page, from, to) => {
        try {
            setLoading(true);
            const response = await dispatch(getTeamPublic({
                team_id: params.id,
                from: moment(from).format('YYYY-MM-DD'),
                to: moment(to).format('YYYY-MM-DD'),
                page: page,
            }));
            setLoading(false);
            setTotalRecords(response.meta.total);
            setCurrentPage(response.meta.current_page);
            listHelper.set(response.data);
        }catch (error) {
            console.log(error);
            setLoading(false);
        }
    }, [params]);

    const onChangeStartDate = useCallback((date) => {
        setStartDate(date);
    }, []);

    const onChangeEndDate = useCallback((date) => {
        setEndDate(date);
    }, []);

    const onChangePage = useCallback((page) => {
        setCurrentPage(page);
        fetchData(page, startDate, endDate);
    }, [startDate, endDate]);

    const onRedirect = useCallback((url) => {
        history.push(url)
    }, []);

    const listCsv = useMemo(() => {
        const lst = [];
        list.forEach(item => {
            lst.push([
                item.transfer_display_date,
                item.team.team_name,
                `${item.player.position_type} ${item.player.uniform_number} ${item.player.player_name}`,
                item.transfer_name,
            ])
        });
        return lst;
    }, [list]);

    return <div className="team-public">
        <div className="wrapper" id='team-public'>
            <div className="block-control">
                <div className="block-control__right">
                    <DatePicker selected={startDate}
                                startDate={startDate}
                                maxDate={endDate}
                                endDate={endDate}
                                dateFormat="yyyy/MM/dd"
                                onChange={onChangeStartDate}
                                className="time-option"
                    />
                    <span>〜</span>
                    <DatePicker selected={endDate}
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                                dateFormat="yyyy/MM/dd"
                                onChange={onChangeEndDate}
                                className="time-option"
                    />
                    <div className="block-button">
                        <CSVLink className={'csv-download'}
                                 headers={['公示日', 'チーム', 'ポジション | 背番号 | 選手名', '選手動向名']}
                                 data={listCsv} filename={'team-public.csv'}>
                            CSVダウンロード
                        </CSVLink>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <Pagination onChangePage={onChangePage}
                                totalPages={totalPage}
                                initialPage={currentPage}
                                pageSize={itemPerPage}
                                showPagination={true}
                    />
                </div>
                <table className='table-app'>
                    <thead>
                        <tr>
                            <th style={{width: '25%'}}>
                                <span>公示日</span>
                            </th>
                            <th style={{width: '25%'}}>
                                <span>チーム</span>
                            </th>
                            <th style={{width: '25%'}}>
                                <span>ポジション | 背番号 | 選手名</span>
                            </th>
                            <th style={{width: '25%'}}>
                                <span>選手動向名</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((item) => {
                            return <tr key={item.id}>
                                <td>{item.transfer_display_date}</td>
                                <td style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}} onClick={() => onRedirect(`/team-report/${item.team.id}`)}>
                                    <img src={detectIconById(item.team.id)} alt="" style={{width: 20, height: 20}}/>
                                    <span style={{flex: 1, paddingLeft: 5}}>{item.team.team_name}</span>
                                </td>
                                <td onClick={() => onRedirect(`/player/${item.player.id}`)} style={{cursor: 'pointer'}}>
                                    <span className='position'>
                                        {item.player.position_type}
                                    </span>
                                    <span>
                                        {`${item.player.uniform_number} ${item.player.player_name}`}
                                    </span>
                                </td>
                                <td>{item.transfer_name}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
                <div>
                    <Pagination onChangePage={onChangePage}
                                totalPages={totalPage}
                                initialPage={currentPage}
                                pageSize={itemPerPage}
                                showPagination={true}
                    />
                </div>
            </div>
        </div>
        <Loading show={loading} />
    </div>
}

export default TeamPublic;
